import React from 'react'
import styles from './ImageViewer.scss'
import cx from 'classnames'
import blockSizes from '../../../App/blockSizes.scss'
import { SingleLineEditor } from 'common/SingleLineEditor'

export const ImageViewer = ({ block }) => {
  const data = block.getData()
  const caption = data.get('caption')
  const src = data.get('src')
  const size = data.get('size', 'normalBlock')
  return (
    <div className={blockSizes[size]}>
      <div className={cx(styles.ImageViewer, styles[size])}>
        <img src={`/photos/large/${src}.jpg`} />
        {caption && <figcaption className={styles.caption}>
          <SingleLineEditor
            defaultValue={caption}
            textAlignment='center'
            readOnly
            type='caption'
          />
        </figcaption>}
      </div>
    </div>
  )
}
